import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    if (error.response?.status === 401 && !cfg._retry && !cfg.url.includes("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export function imgSrc(photo) {
  if (!photo) return "/images/hero.jpg";
  if (photo.startsWith("http") || photo.startsWith("/")) return photo;
  return `${API}/files/${photo}`;
}

export const money = (cents) => `$${((cents || 0) / 100).toFixed(2)}`;

export const ROLE_LABEL = { sugar_daddy: "Sugar Daddy", sugar_mommy: "Sugar Mommy", sugar_baby: "Sugar Baby" };

export async function startCheckout(lookup_key) {
  const { data } = await api.post("/payments/checkout", { lookup_key, origin_url: window.location.origin });
  window.location.href = data.checkout_url;
}
